import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../styles/pages/Contact.scss';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    error: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simulando envio de formulário (em uma implementação real, isso seria uma chamada API)
    setFormStatus({ submitted: true, success: false, error: null });
    
    // Simulação de uma resposta bem-sucedida após 1 segundo
    setTimeout(() => {
      setFormStatus({
        submitted: false,
        success: true,
        error: null
      });
      
      // Limpar o formulário
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      
      // Resetar mensagem de sucesso após 5 segundos
      setTimeout(() => {
        setFormStatus({
          submitted: false,
          success: false,
          error: null
        });
      }, 5000);
    }, 1000);
  };

  return (
    <motion.div
      className="contact-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="container">
        <motion.h1
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1 }}
        >
          Entre em Contato
        </motion.h1>
        
        <div className="contact-content">
          <motion.div 
            className="contact-info"
            initial={{ x: -30, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            
            <div className="info-item">
              <h3>Contato</h3>
              <p>tami.pijamas@gmail.com.br</p>
              <p>(16) 99261-3356</p>
            </div>
            
            <div className="info-item">
              <h3>Horário de Atendimento</h3>
              <p>Segunda a Sexta: 9h às 18h</p>
              <p>Sábado: 9h às 13h</p>
            </div>
            
            <div className="social-links">
              <h3>Redes Sociais</h3>
              <div className="social-icons">
                <a href="https://www.instagram.com/lunapijamas3/" target="_blank" rel="noopener noreferrer">Instagram</a>
                
              </div>
            </div>
          </motion.div>
          
          <motion.div 
            className="contact-form"
            initial={{ x: 30, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <h2>Envie uma Mensagem</h2>
            
            {formStatus.success && (
              <div className="form-success-message">
                Sua mensagem foi enviada com sucesso! Entraremos em contato em breve.
              </div>
            )}
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Nome</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">E-mail</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="subject">Assunto</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Mensagem</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  required
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                className="submit-button"
                disabled={formStatus.submitted}
              >
                {formStatus.submitted ? 'Enviando...' : 'Enviar Mensagem'}
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default Contact; 